import React, { useState } from "react";

import PageWrapper from "WebVisual/PageWrapper";
import FavouriteArticles from "WebVisual/Components/FavouriteArticles";
import ChatWidget from "WebVisual/Components/ChatWidget";
import { useGetLastChatInfo } from "WebVisual/Components/ChatWidget/hooks";

const Favourite = () => {
  const [search, setSearch] = useState("");

  const { lastCreatedChat, requesting } = useGetLastChatInfo();

  return (
    <PageWrapper
      onChange={setSearch}
      title="Favourite"
      pageBodyHeader={
        lastCreatedChat ? <ChatWidget lastCreatedChat={lastCreatedChat} requesting={requesting} /> : undefined
      }
    >
      <FavouriteArticles search={search} />
    </PageWrapper>
  );
};

export default Favourite;
